import { createContext } from "react";

export const ScrollContext = createContext<null | {
  setCanScroll: (arg0: boolean) => void;
}>(null);
ScrollContext.displayName = "ScrollContext";
